// @flow
import _ from 'lodash';
import { Tracking } from 'web-core/src/tracking';

export const trackAccordionClick = (tracker: string, state: Object) => {
  const currentTab = _.get(state, 'panel.props.title.props.children');
  const isTabOpen = _.get(state, 'panel.props.isOpen', true);

  if (state.index !== null && !isTabOpen) {
    Tracking.track(tracker, { currentTab });
  }
};
